import { Event } from './event';

export interface Result {
  event: Event;
  code: number;
  message: string;
}
